import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { CacheService } from './cache.service';
import { Observable } from 'rxjs/Observable';
import { tap, catchError } from 'rxjs/operators';
import { RequestResult } from '../models/common/requestResult';
import { Salary } from '../models/salaries/salary';
import { SalaryReport } from '../models/salaries/salaryReport';

@Injectable()
export class SalaryService {
	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getSalary(id: string): Observable<Salary> {
		return this._http.get<Salary>(`${this.origin}/api/salaries/${id}`)
			.pipe(
				tap(x => this.log(`getSalary: id=${id}`)),
				catchError(this._logService.handleError<Salary>('getSalary'))
			);
	}

	getUserSalaryList(userId: number): Observable<Salary[]> {
		return this._http.get<Salary[]>(`${this.origin}/api/salaries?userId=${userId}`)
			.pipe(
				tap(x => this.log(`getUserSalaryList userId = ${userId}`)),
				catchError(this._logService.handleError<Salary[]>('getUserSalaryList'))
			);
	}

	getUserSalaryReport(userId: number, dateFrom: string, dateTo: string): Observable<SalaryReport> {
		return this._http.get<SalaryReport>(`${this.origin}/api/salaries/report?userId=${userId}&from=${dateFrom}&to=${dateTo}`)
			.pipe(
				tap(x => this.log(`getUserSalaryReport from=${dateFrom}, to=${dateTo}`)),
				catchError(this._logService.handleError<SalaryReport>('getUserSalaryReport'))
			);
	}

	getSalaryReport(dateFrom: string, dateTo: string, employeeRole?: string): Observable<SalaryReport[]> {
		let url = `${this.origin}/api/salaries/report?from=${dateFrom}&to=${dateTo}&employeeRole=`;
		if(employeeRole != null && employeeRole != undefined){
			url += employeeRole;
		}

		return this._http.get<SalaryReport[]>(url)
			.pipe(
				tap(x => this.log(`getSalaryReport from=${dateFrom}, to=${dateTo}, employeeRole=${employeeRole}`)),
				catchError(this._logService.handleError<SalaryReport[]>('getSalaryReport'))
			);
	}

	addSalary(salary: Salary): Observable<RequestResult<Salary>> {
		return this._http.post<RequestResult<Salary>>(`${this.origin}/api/salaries`, JSON.stringify(salary))
			.pipe(
				tap(x => this.log(`addSalary: id=${salary.id}`)),
				catchError(this._logService.handleError<RequestResult<Salary>>('addSalary'))
			);
	}

	updateSalary(salary: Salary): Observable<RequestResult<Salary>> {
		return this._http.put<RequestResult<Salary>>(`${this.origin}/api/salaries/${salary.id}`, JSON.stringify(salary))
			.pipe(
				tap(x => this.log(`updateSalary: id=${salary.id}`)),
				catchError(this._logService.handleError<RequestResult<Salary>>('updateSalary'))
			);
	}

	private log(message: string) {
		this._messagesService.add('SalaryService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/salary.service.ts